import en_Image from '@/assets/flags/en.svg'
import es_CLImage from '@/assets/flags/es-CL.svg'
import es_COImage from '@/assets/flags/es-CO.svg'
import es_DOImage from '@/assets/flags/es-DO.svg'
import es_MXImage from '@/assets/flags/es-MX.svg'
import es_PEImage from '@/assets/flags/es-PE.svg'
import he_ILImage from '@/assets/flags/he-IL.svg'
import pt_PTImage from '@/assets/flags/pt-PT.svg'
import ro_ROImage from '@/assets/flags/ro-RO.svg'
import zh_CNImage from '@/assets/flags/zh-CN.svg'

export const supportedLanguages = [
  {
    id: 'en',
    desc: 'English',
    image: en_Image,
  },
  {
    id: 'es-CL',
    desc: 'Español (CL)',
    image: es_CLImage,
  },
  {
    id: 'es-CO',
    desc: 'Español (CO)',
    image: es_COImage,
  },
  {
    id: 'es-MX',
    desc: 'Español (MX)',
    image: es_MXImage,
  },
  {
    id: 'es-PE',
    desc: 'Español (PE)',
    image: es_PEImage,
  },
  {
    id: 'es-DO',
    desc: 'Español (DO)',
    image: es_DOImage,
  },
  {
    id: 'he-IL',
    desc: 'עברית',
    image: he_ILImage,
  },
  {
    id: 'pt-PT',
    desc: 'Português',
    image: pt_PTImage,
  },
  {
    id: 'ro-RO',
    desc: 'Română',
    image: ro_ROImage,
  },
  {
    id: 'zh-CN',
    desc: '中文',
    image: zh_CNImage,
  },
]
